import React, { useState } from 'react';
import { Menu } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getAndSaveUser } from 'services/auth';
import { getItensMenuDefault } from './Menu';
import HeaderTema from '../Menu/Tema/index';
import * as S from './styles';

export const MenuSistema = () => {
  const { SubMenu } = Menu;
  const history = useHistory();
  const dispatch = useDispatch();
  const prefixo = 'rc-menu';

  const user = useSelector(state => state.sefaz.userProfile);
  const modalAcessoNegado = useSelector(state => state?.app?.modalAcessoNegado);

  const [current, setCurrent] = useState('fas');

  React.useEffect(() => {
    if (!user) getAndSaveUser();
  }, [dispatch, user]);

  const handleClick = e => {
    setCurrent(e.key);

    let keys = e.keyPath.filter(item => !item.startsWith(prefixo));
    let pathMenu = keys.length;
    let obj = getItensMenuDefault(user);

    do {
      obj = obj?.find(menu => menu.id === keys[pathMenu - 1]); // eslint-disable-line

      if (obj.id === e.key) history.push(obj?.rota);
      else obj = obj.subMenu;

      pathMenu -= 1;
    } while (pathMenu > 0);
  };

  const renderMenuUnico = item => {
    return (
      <Menu.Item id={item.id} key={item.id} icon={item.icon} disabled={item.disabled}>
        {item.titulo}
      </Menu.Item>
    );
  };

  const renderSubMenu = item => {
    return item.subMenu.map(sub => {
      return sub.view && sub?.subMenu?.length > 0 ? (
        <SubMenu key={sub.id} icon={sub.icon} title={sub.titulo} disabled={sub.disabled}>
          {sub?.subMenu?.map(item => {
            return (
              item.view && (
                <Menu.Item key={item.id} icon={item.icon} disabled={item.disabled}>
                  {item.titulo}
                </Menu.Item>
              )
            );
          })}
        </SubMenu>
      ) : (
        sub.view && (
          <Menu.Item key={sub.id} icon={sub.icon} disabled={sub.disabled}>
            {sub.titulo}
          </Menu.Item>
        )
      );
    });
  };

  return (
    <S.Contain>
      <Menu onClick={handleClick} selectedKeys={[current]} mode="horizontal">
        {getItensMenuDefault(user, modalAcessoNegado?.isOpen)
          .filter(x => x.view)
          ?.map(item => {
            return !item?.subMenu ? (
              renderMenuUnico(item)
            ) : (
              <SubMenu key={item.id} icon={item.icon} title={item.titulo} disabled={item.disabled}>
                {renderSubMenu(item)}
              </SubMenu>
            );
          })}
      </Menu>
      <HeaderTema />
    </S.Contain>
  );
};

export default MenuSistema;
